<template>
  <div>
    <app-component-empty-state v-if="loading == false && desserts.length == 0" 
      :title="'Ops! Não existem canais cadastrados'" 
      :text="'Clique em “Novo Canal” no menu de Canais para começar a cadastrar um novo canal ao sistema.'">
    </app-component-empty-state>
    <v-card v-else>
        <v-col md="5" class="mb-4">
          <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar Canais"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
        <v-data-table
          :loading="loading" loading-text="Carregando..."
          :headers="headers"
          :items="desserts"
          :search="search"
        >
          <template v-slot:item.is_authorized="{ item }">
            <span v-if="item.is_authorized">Autorizado</span>
            <span v-else class="blue--text text--darken-3 pointer" @click="authChannel(item.id_youtube_channel)">Aguardando</span>
          </template>
        </v-data-table>
    </v-card>
  </div>
</template>

<script>
import EmptyState from '../components/EmptyState.vue'

export default {
    components: {
      'app-component-empty-state': EmptyState
    },
    created() {
      this.getChannels();
    },
    data: () => ({
        search: '',
        loading: true,
        headers: [
          { text: 'Nome', align: 'start', sortable: true, value: 'name' },
          { text: 'Status', align: 'start', sortable: true, value: 'is_authorized' }
        ],
        desserts: []
    }),
    methods: {
      getChannels() {
        this.$http.get( '/channel/allowed' )
        .then( ( res ) => {
          this.desserts = res.data;
        } ).finally( () => {
          this.loading = false;
        } );
      },
      authChannel(channel) {
         this.$http.post( '/youtube-auth', {
          id_youtube_channel: channel,
        })
        .then( (res) => {
          window.open(res.data.url, "authwindow", "height=580,width=620")
        })
      }
    }
}
</script>

<style scoped>
  .d-content {
    display: contents !important;
  }
  .table-min-height {
    min-height: 60vh;
  }
</style>